// @ts-nocheck
'use client';
import {useRef} from 'react';
import {useServerInsertedHTML} from 'next/navigation';
import {StyleSheet} from 'react-native';

export default function RNStyleProvider({children}: {children: React.ReactNode}) {
  const attached = useRef(false);
  useServerInsertedHTML(() => {
    if (attached.current) return;
    attached.current = true;

    const sheet = StyleSheet.getSheet();
    return <style dangerouslySetInnerHTML={{__html: sheet.textContent}} id={sheet.id} />;
  });
  return <>{children}</>;
}
